import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "../../../modules/material/material.module";
import { HeaderModule } from "../../shared/components/layout/header/header.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { MusicOnHoldPageComponent } from "./musicOnHoldPage/music-on-hold-page.component";
import { ManageMusicOnHoldDialogComponent } from "./manageMusicOnHoldDialog/manage-music-on-hold-dialog.component";
import { EditMusicSourceDialogModule } from "../../shared/components/editMusicSourceDialog/edit-music-source-dialog.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MusicOnHoldRoutingModule } from "./music-on-hold-routing.module";
import { RouterModule } from "@angular/router";
import { TableModule } from "@onsip/web/features/shared/components/table/onsip-table.module";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    HeaderModule,
    PipesModule,
    EditMusicSourceDialogModule,
    RouterModule,
    MusicOnHoldRoutingModule,
    TableModule,
    LoadingContainerComponent
  ],
  declarations: [MusicOnHoldPageComponent, ManageMusicOnHoldDialogComponent]
})
export class MusicOnHoldModule {}
